/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Translation_ImportInputs */

const en_translation_import = /** @type {(inputs: Translation_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Translation Import...`)
};

const fr_translation_import = /** @type {(inputs: Translation_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importation de traduction...`)
};

const de_translation_import = /** @type {(inputs: Translation_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übersetzung importieren...`)
};

const it_translation_import = /** @type {(inputs: Translation_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importazione traduzione...`)
};

const ru_translation_import = /** @type {(inputs: Translation_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Импорт перевода...`)
};

const es_translation_import = /** @type {(inputs: Translation_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importación de traducción...`)
};

const zh_cn2_translation_import = /** @type {(inputs: Translation_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`翻译导入...`)
};

const ja_translation_import = /** @type {(inputs: Translation_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`翻訳のインポート...`)
};

const hi_translation_import = /** @type {(inputs: Translation_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अनुवाद आयात...`)
};

const pt_pt2_translation_import = /** @type {(inputs: Translation_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importação de traduções...`)
};

/**
* | output |
* | --- |
* | "Translation Import..." |
*
* @param {Translation_ImportInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const translation_import = /** @type {((inputs?: Translation_ImportInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Translation_ImportInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_translation_import(inputs)
	if (locale === "de") return de_translation_import(inputs)
	if (locale === "it") return it_translation_import(inputs)
	if (locale === "ru") return ru_translation_import(inputs)
	if (locale === "es") return es_translation_import(inputs)
	if (locale === "zh-CN") return zh_cn2_translation_import(inputs)
	if (locale === "ja") return ja_translation_import(inputs)
	if (locale === "hi") return hi_translation_import(inputs)
	if (locale === "pt-PT") return pt_pt2_translation_import(inputs)
	return en_translation_import(inputs)
});